import { TextField } from '@mui/material';
import * as React from 'react';
import { Fragment, useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';

export interface ShareWithUserFormProps {
  submitHander: (name: string, email: string, write: boolean) => void;
  loading: boolean;
}

const ShareWithUserForm = (props: ShareWithUserFormProps) => {
  const [email, setEmail] = useState<string>('');
  const [name, setName] = useState<string>('');
  const { t } = useTranslation();
  // const [write, setWrite] = useState<string>(false);
  return (
    <Fragment>
      <TextField
        fullWidth
        type="text"
        value={name}
        label="Nombre"
        onChange={(event) => {
          setName(event.target.value);
        }}
        sx={{ mt: 1, mb: 2 }}
      />
      <TextField
        fullWidth
        type="email"
        value={email}
        label="Email"
        onChange={(event) => {
          setEmail(event.target.value);
        }}
      />
      {/*<FormGroup>
        <FormControlLabel control={<Checkbox defaultChecked />} label="Label" />
      </FormGroup>*/}
      <LoadingButton
        sx={{ marginTop: '25px' }}
        variant={'contained'}
        loading={props.loading}
        onClick={() => {
          props.submitHander(name, email, false);
        }}
      >
        {t('invite')}
      </LoadingButton>
    </Fragment>
  );
};
export default ShareWithUserForm;
